import React from "react";
import QuizContent from "../shared/QuizContent";
import ProgressBars from "../shared/ProgressBars";
import TestimonialsSlider from "../shared/TestimonialsSlider";

const Progress = ({ onContinue }) => {
  setTimeout(() => {
    onContinue();
  }, 5000);

  return (
    <QuizContent className="loading-page">
      <div className="loading-container">
        {/* Loading Spinner */}
        <div className="loading-spinner">
          <span className="loader"></span>
        </div>

        {/* Title */}
        <h1 className="loading-title">Creating your AI character</h1>

        {/* Progress Bars */}
        <ProgressBars />

        {/* Testimonials Slider */}
        <TestimonialsSlider />
      </div>
    </QuizContent>
  );
};

export default Progress;
